// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"e84609e6","4200":"87b89491","5122":"1f3a2121","5912":"aec78970","6467":"7b895dc0"}[chunkId] + ".css";
};